import { render, staticRenderFns } from "./amount-flow-statistical-list.vue?vue&type=template&id=eb17970e&scoped=true&"
import script from "./amount-flow-statistical-list.vue?vue&type=script&lang=ts&"
export * from "./amount-flow-statistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb17970e",
  null
  
)

export default component.exports